export default {
    // "apiUrl": 'https://24-dashapi.ballxbet.com/admin/',
    // "mobileApiUrl": 'https://24-dashapi.ballxbet.com/',
    // "mediaUrl": 'https://24-dashapi.ballxbet.com',

    "apiUrl": 'https://football-api.cactusminds.com/admin/',
    "mobileApiUrl": 'https://football-api.cactusminds.com/',
    "mediaUrl": 'https://football-api.cactusminds.com',

    // "apiUrl": 'http://localhost:8000/admin/',
    // "mobileApiUrl": 'http://localhost:8000/',
    // "mediaUrl": 'http://localhost:8000',
}